import React from "react";
import { Placeholder } from "../../../logic/page";


export default function Row(props) {
  let className = props.className || "";
  if (props.reverse) {
    className += " row-reverse";
  }

  return (<div style={props.style} testid={props.testid} className={`row ${className}`}>
    {props.placeholder && <Placeholder name={props.placeholder} />}
    {props.children}
  </div>);
}
Row.displayName = "Row";

